import api from "!../../../../../graylog2-server/graylog2-web-interface/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../graylog2-server/graylog2-web-interface/node_modules/css-loader/dist/cjs.js!./AuditLogStatus.css";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};